module.exports = __webpack_public_path__ + "static/img/pop_btn_back.3f73931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/pop_btn_back.png
// module id = FEuY
// module chunks = 156